import { app } from '../../../../../bootstrap/core';
import { confirmWarrantState } from './confirmWarrant.state';
import { confirmWarrantComponent } from './confirmWarrant.component';
import { TransferringConfirmWarrantService } from './confirmWarrant.service';
import '../../../../../common/ui/paymentPartners/paymentPartners';
import transferringConfirmPendingPartial from '../../../../ticket/partials/ticket.statusPending.tpl.html';
import './components/components';

app.config(confirmWarrantState);
app.component(confirmWarrantComponent.name, confirmWarrantComponent);
app.service(
  'transferringConfirmWarrantService',
  TransferringConfirmWarrantService,
);
app.value(
  'transferringConfirmPendingPartial',
  transferringConfirmPendingPartial,
);
